import React from 'react';

export default function WorldModal({
  selectedWorldModal,
  setSelectedWorldModal,
  theme,
  TROPHY_DEFINITIONS
}) {
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-md z-50 flex items-center justify-center p-6 animate-fadeIn">
      <div className={`${theme.card} border ${theme.border} rounded-[2.5rem] p-8 max-w-sm w-full space-y-6 shadow-2xl`}>
        <div className={`flex justify-between items-start border-b ${theme.border} pb-4`}>
          <div>
            <span className={`text-[10px] ${theme.muted} font-bold tracking-widest block uppercase mb-1`}>Fase Actual</span>
            <h3 className={`text-xl font-black leading-tight ${theme.text}`}>{selectedWorldModal.title}</h3>
          </div>
          <button onClick={() => setSelectedWorldModal(null)} className={`${theme.muted} font-bold text-xl`}>✕</button>
        </div>
        <div className="space-y-3">
          <span className={`text-[10px] ${theme.muted} font-bold block uppercase tracking-widest`}>Ítems</span>
          <div className="grid grid-cols-2 gap-3">
            {selectedWorldModal.items.map((item, idx) => (
              <div key={idx} className={`${theme.secondary} p-3 rounded-2xl border ${theme.border} text-[10px] font-bold uppercase tracking-wide flex items-center ${theme.text}`}>{item}</div>
            ))}
          </div>
        </div>
        <div className="space-y-3">
          <span className={`text-[10px] ${theme.muted} font-bold block uppercase tracking-widest`}>Trofeos</span>
          <div className="grid grid-cols-2 gap-3">
            {selectedWorldModal.trophies.map((trophyId) => {
              const trophy = TROPHY_DEFINITIONS[trophyId];
              return (
                <div key={trophyId} className={`p-4 ${theme.secondary} border ${theme.border} rounded-2xl flex flex-col items-center text-center gap-2`}>
                  <span className="text-2xl">{trophy.icon}</span>
                  <div>
                    <h4 className={`text-[10px] font-bold uppercase tracking-widest mb-1 ${theme.text}`}>{trophy.title}</h4>
                    <p className={`text-[9px] ${theme.muted}`}>{trophy.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <button onClick={() => setSelectedWorldModal(null)} className={`w-full py-4 ${theme.primary} font-black uppercase tracking-widest rounded-full text-xs`}>CONTINUAR</button>
      </div>
    </div>
  );
}